import script from "./target.vue?vue&type=script&setup=true&lang=js"
export * from "./target.vue?vue&type=script&setup=true&lang=js"

import "./target.vue?vue&type=style&index=0&id=2cb6bc69&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb6bc69"]])

export default __exports__